<div id="notfound">
    <div class="notfound">
        <h2>{{ 'InvalidLink' | translate}}</h2>
        <p>{{ 'LinkExpired' | translate }}</p>
    </div>
</div>
